import { Injectable } from '@angular/core';
import { appWindow, LocalStorage } from '../../AppWindow';

@Injectable()
export class FeatureHeroService {
  private readonly _defaultFeatureHeroVersion: string = '0.0.0';

  private localStorage: LocalStorage = appWindow.localStorage;

  constructor() {}

  public setFeatureHeroVersion(version: string): string {
    this.localStorage.setItem('FeatureHeroVersion', version);
    return version;
  }

  public getFeatureHeroVersion(): string {
    const version: string | null = this.localStorage.getItem('FeatureHeroVersion');
    if (version) {
      return version;
    } else {
      return this._defaultFeatureHeroVersion;
    }
  }
}
